var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.shown)?_c('img',{attrs:{"src":"/images/icon/swipe.gif"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }